// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qf_a bhc_su bhc_kv bhc_kw","PostDetailRight__brandDaysPosts":"qf_b bhc_su bhc_kv bhc_kw"};